import React from 'react';
import ConfirmDeliveryView from './popin/confirm-delivery';
import PickupOpeningTimesView from './popin/pickup-opening-times';
import SellerConfirmDeliveryView from './popin/seller-confirm-delivery';
import RelistView from './popin/relist';
import ReturnFormView from './popin/return-form';
import { Popin } from './type';
import SaleReportView from './popin/sale-report';
import SelectCarrierAndOptions from './popin/get-shipping-label/select-carrier-options';
import UpdateShippingAddressModal from './popin/update-shipping-address/update-shipping-address-modal';

const View: React.FC<{
  popin: Popin | null;
  closePopin: () => void;
}> = ({ popin, closePopin }) => {
  if (popin == null) {
    return <></>;
  }

  switch (popin.kind) {
    case 'PickupOpeningTimes':
      return (
        <PickupOpeningTimesView
          closePopin={closePopin}
          openingTimes={popin.openingTimes}
        />
      );
    case 'Relist':
      return (
        <RelistView
          closePopin={closePopin}
          product={popin.product}
          order={popin.order}
          relistDetails={popin.relistDetails}
        />
      );
    case 'ConfirmDelivery':
      return (
        <ConfirmDeliveryView
          closePopin={closePopin}
          product={popin.product}
          order={popin.order}
          confirmDeliveryDetails={popin.confirmDeliveryDetails}
        />
      );
    case 'SellerConfirmDelivery':
      return (
        <SellerConfirmDeliveryView
          closePopin={closePopin}
          product={popin.product}
          order={popin.order}
          confirmDeliveryDetails={popin.confirmDeliveryDetails}
        />
      );
    case 'ReturnForm':
      return (
        <ReturnFormView
          closePopin={closePopin}
          product={popin.product}
          order={popin.order}
          returnReasons={popin.returnReasons}
        />
      );
    case 'SaleReport':
      return (
        <SaleReportView
          rootSaleReport={popin.rootSaleReport}
          saleReports={popin.saleReports}
          closePopin={closePopin}
        />
      );
    case 'GetShippingLabel':
      return (
        <SelectCarrierAndOptions
          closePopin={closePopin}
          product={popin.product}
          address={popin.address}
        />
      );
    case 'UpdateAddress':
      return <UpdateShippingAddressModal onClose={closePopin} />;
    default:
      return null;
  }
};

export default View;
